import { Button, Dialog, DialogContent, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import { useRouter } from "next/navigation";

interface DialogSuccessProps {
	className?: string;
	isOpen?: boolean;
	onClose?: () => void;
}
const DialogSuccess: React.FC<DialogSuccessProps> = ({
	className,
	isOpen = false,
	onClose,
}) => {
	const router = useRouter();
	return (
		<Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="xs">
			<DialogContent className="p-6 md:p-8">
				<div className="thumbnail mx-auto text-center mb-12">
					<img
						src="/assets/images/refund-request-success.svg"
						alt="image"
						className="inline-block mx-auto"
					/>
				</div>
				<div className="text-center">
					<Typography className="font-semibold text-3xl mb-2">
						Hoàn tất
					</Typography>
					<Typography component="p" className="text-gray-500 mb-8">
						Chúc mừng bạn đã tạo khảo sát thành công.
					</Typography>
					<Button
						color="primary"
						variant="outlined"
						size="large"
						className="w-full"
						onClick={() => router.push("/")}
					>
						Về trang chủ
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};

const useDialog = () => {
	const [isOpen, setIsOpen] = useState(false);

	const openDialog = useCallback(() => {
		setIsOpen(true);
	}, []);

	const closeDialog = useCallback(() => {
		setIsOpen(false);
	}, []);
	return {
		isOpen,
		openDialog,
		closeDialog,
	};
};

export default Object.assign(DialogSuccess, { useDialog: useDialog });
